import { useEffect, useRef } from "react";
import { Form } from "antd";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import TextField from "@/common/elements/InputElements/TextField";
import { StyledGridCol, StyledGridRow, StyledSectionHeading } from "@/common/styles";
import useActiveWarrant from "@/hooks/useActiveWarrant";

const WarrantComments = () => {
  const [form] = Form.useForm();
  const { activeWarrant, bookingsFieldsEnabled, patch } = useActiveWarrant();
  const debounceComments = useRef(null);

  useEffect(() => {
    if (!activeWarrant) return;
    form.setFieldsValue({ comments: activeWarrant?.comments ?? "" });
  }, [activeWarrant?.warrantId]);

  useEffect(() => {
    return () => { if (debounceComments.current) clearTimeout(debounceComments.current); };
  }, []);

  const patchComments = (val) => {
    if (debounceComments.current) clearTimeout(debounceComments.current);
    debounceComments.current = setTimeout(() => patch({ comments: val }), 300);
  };

  return (
    <>
      <StyledSectionHeading marginTop="20px">
        <span>Comments</span>
      </StyledSectionHeading>

      <Form form={form} disabled={!bookingsFieldsEnabled}>
        <StyledGridRow gutter={16}>
          <StyledGridCol lg={24}>
            <FormItem label="Warrant Comments" name="comments">
              <TextField
                inputType="textarea"
                rows="3"
                onChange={(e) => patchComments(e?.target?.value ?? e)}
              />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>
      </Form>
    </>
  );
};

export default WarrantComments;
